import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccessTypeDetailComponent } from './access-type-detail.component';
import { CoreModule } from 'app/core/core.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
  ],
  declarations: [AccessTypeDetailComponent],
  entryComponents: [AccessTypeDetailComponent]
})
export class AccessTypeDetailModule { }
